import styled from 'styled-components'
import Card from '../../../../components/card'

/**
 * Avisos Relacionados
 */

export const EmpleosRelacionadosContainer = styled.div``

export const Header = styled.div`
  margin-bottom: 10px;
`

export const ListadoAvisoCard = styled(Card)`
  margin-bottom: 12px;
`

export const EmpleosRelacionadosComponent = styled.div``
